import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { DemoProvider } from './context/DemoContext';
import AppShell from './components/layout/AppShell';
import AgeGate from './components/xc/AgeGate';
import Seo from './components/xc/Seo';
import Landing from './pages/Landing';
import City from './pages/City';
import Casino from './pages/Casino';
import District from './pages/District';
import ProviderGame from './pages/ProviderGame';
import Missions from './pages/Missions';
import CrewVsCrew from './pages/CrewVsCrew';
import TerritoryWars from './pages/TerritoryWars';
import LoyaltyJob from './pages/LoyaltyJob';
import Crew from './pages/Crew';
import Profile from './pages/Profile';
import Shop from './pages/Shop';
import SafePlay from './pages/SafePlay';
import Trust from './pages/Trust';
import NotFound from './pages/NotFound';
import Admin from './pages/Admin';

function Shelled({ children }) {
  return <AppShell>{children}</AppShell>;
}

function App() {
  return (
    <div className="App">
      <DemoProvider>
        <BrowserRouter>
          <Seo />
          <AgeGate />
          <Routes>
            <Route path="/" element={<Shelled><Landing /></Shelled>} />
            <Route path="/city" element={<Shelled><City /></Shelled>} />
            <Route path="/district/:id" element={<Shelled><District /></Shelled>} />
            <Route path="/casino" element={<Shelled><Casino /></Shelled>} />
            <Route path="/game/provider-demo" element={<ProviderGame />} />
            <Route path="/missions" element={<Shelled><Missions /></Shelled>} />
            <Route path="/competitions/crew-vs-crew" element={<Shelled><CrewVsCrew /></Shelled>} />
            <Route path="/competitions/territory-wars" element={<Shelled><TerritoryWars /></Shelled>} />
            <Route path="/missions/loyalty-job" element={<Shelled><LoyaltyJob /></Shelled>} />
            <Route path="/missions/solo-run" element={<Shelled><LoyaltyJob solo /></Shelled>} />
            <Route path="/crew" element={<Shelled><Crew /></Shelled>} />
            <Route path="/profile" element={<Shelled><Profile /></Shelled>} />
            <Route path="/shop" element={<Shelled><Shop /></Shelled>} />
            <Route path="/safe-play" element={<Shelled><SafePlay /></Shelled>} />
            <Route path="/trust" element={<Shelled><Trust /></Shelled>} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Shelled><NotFound /></Shelled>} />
          </Routes>
        </BrowserRouter>
      </DemoProvider>
    </div>
  );
}

export default App;
